/**
 * Fases del proyecto audiovisual.
 *
 * Paleta alineada al Mockup D (brandbook 2022): cada fase tiene un hex exacto
 * que se usa tanto en el dot del Kanban como en el badge dentro de tarjetas y
 * cabeceras. Las clases Tailwind `bg-*` / `text-*` se mantienen para los
 * fallbacks dentro de pills (donde el hex puro no aplica como utility class).
 *
 * Orden cronológico de producción.
 */

export const PROJECT_PHASES = [
  "IDEA",
  "DESARROLLO",
  "FINANCIACIÓN",
  "PREPRODUCCIÓN",
  "PRODUCCIÓN",
  "DISTRIBUCIÓN",
];

export const DEFAULT_PHASE = "IDEA";

/**
 * Color por fase.
 * - `hex`: color exacto del mockup (uso inline en dots, bordes, lanes).
 * - `bg` / `text` / `dot`: clases Tailwind para badges/pills.
 * - `label`: capitalización amable para UI.
 */
export const PHASE_STYLES = {
  IDEA: {
    hex: "#B8B5AD",
    bg: "bg-stone-200",
    text: "text-stone-700",
    dot: "bg-stone-500",
    label: "Idea",
  },
  DESARROLLO: {
    hex: "#C9821B",
    bg: "bg-amber-100",
    text: "text-amber-900",
    dot: "bg-amber-600",
    label: "Desarrollo",
  },
  FINANCIACIÓN: {
    hex: "#E59C2C",
    bg: "bg-orange-100",
    text: "text-orange-900",
    dot: "bg-orange-500",
    label: "Financiación",
  },
  PREPRODUCCIÓN: {
    hex: "#5B7A8E",
    bg: "bg-sky-100",
    text: "text-sky-900",
    dot: "bg-sky-600",
    label: "Preproducción",
  },
  PRODUCCIÓN: {
    hex: "#2E7D5B",
    bg: "bg-emerald-100",
    text: "text-emerald-900",
    dot: "bg-emerald-600",
    label: "Producción",
  },
  DISTRIBUCIÓN: {
    hex: "#7C4D9C",
    bg: "bg-purple-100",
    text: "text-purple-900",
    dot: "bg-purple-500",
    label: "Distribución",
  },
};

/** Devuelve el estilo de fase. Fallback a IDEA si la fase es desconocida. */
export function phaseStyle(phase) {
  return PHASE_STYLES[phase] || PHASE_STYLES[DEFAULT_PHASE];
}
